import $ from "jquery";
import { initRatingStarsList } from '../../modules/rating.inline';

$(document).ready(function (){
    initRatingStarsList();
});


// WEBPACK FOOTER //
// ./blocks/index-block-action/index-block-action.js